import React, { useState, useEffect } from "react";
import user from "../../assets/user2.png";
import ig from "../../assets/instagram.png"
import '../App.css';

function InstaFirst({layout,testimonial,media,hashtag,name,profile,colorTheme,time}) {
  const [displayText, setDisplayText] = useState('');
  const [isValid, setIsValid] = useState(true);
  const [fade,setFade]=useState(false);

  useEffect(()=>{
    setTimeout(() => {
      setFade(true)
    }, time-1000);
  })

  const handleImageError = () => {
    setIsValid(false);
  };

  useEffect(() => {
    let i = 0;
    const interval = setInterval(() => {
      if (i < testimonial.length) {
        const currentChar = testimonial.charAt(i);
        setDisplayText(prevText => prevText + currentChar);
        i++;
      } else {
        clearInterval(interval);
      }
    }, 20);
  
    return () => clearInterval(interval);
  }, [testimonial]);

  function getProxiedImageUrl(src) {
    try {
      const proxiedImageUrl = `https://api.allorigins.win/raw?url=${encodeURIComponent(src)}`;
      return proxiedImageUrl;
    }
    catch (error) { 
      console.error('Error occurred while generating proxied URL:', error);
      return null; 
    }
  }
const business = localStorage.getItem("BusinessName")
  
  return (
    layout === "Landscape"?(
    <div>
      
      <div
        className={`content-box-insta ${fade ? 'close-book' : ''}`}
        style={{
          position: "absolute",
          left: business==="Drive X Mobility "?"27vw":"10vw",
          top: business==="Drive X Mobility "?"22vh":"19vh",
          background: "white",
          borderRadius: "30px",
          width: "20vw",
          maxHeight:"80vh",
          padding: "5px 17px 17px 17px",
        }}
      >
           <p style={{ color: colorTheme?colorTheme:"#703484", fontWeight: "300", fontSize: "2.2vw", margin: "-1vh 0 0vh 0",fontStyle:"italic",minHeight:"3vh" }} className="animated-title">{hashtag&&"#"+hashtag}</p>
         <div style={{ position: 'relative', display: 'inline-block' }}>
  <img
    src={media}
    className="profile-img"
    style={{
      width: '20vw',
      height: 'auto',
      transition: 'transform 1s ease-in-out'
    }}
  />
  <img
    src={ig}
    style={{
      position: 'absolute',
      top: '1vh',
      right: '0.5vw',
      width: '25px', // adjust this value as needed
      height: 'auto', // or set a fixed height if needed
      zIndex: 1 // ensure it's on top of the original image
    }}
  />
</div>
<div style={{display:"flex",gap:"0.5vw",justifyContent:"center",alignItems:"center"}}>
<img onError={handleImageError}
        src={profile&&isValid?getProxiedImageUrl(profile):user}
        className="profile-img"
        width={name?30:0}
        style={{
          height:"auto",
          borderRadius:"50%",
          border: "3px solid white",
          transition: "transform 1s ease-in-out"
        }}
      />
<p style={{ color:colorTheme?colorTheme:"#703484", fontWeight: "600", fontSize: "1.7vw", margin: "0" }} className="animated-text">{name?name:""}</p>
</div>
        <p style={{ color: "black", fontWeight: "400", margin: "0",fontSize: "1.4vw"  }} className="animated-first">{testimonial}</p>
      </div>
    </div>
    ):(
      <div>
      
      <div
        className={`content-box-insta ${fade ? 'close-book' : ''}`}
        style={{
          position: "absolute",
          left: "10vw",
          top: "15vh",
          background: "white",
          borderRadius: "30px",
          width: "52vw",
          maxHeight:"80vh",
          padding: "5px 17px 17px 17px",
        }}
      >
           <p style={{ color:colorTheme?colorTheme:"#703484", fontWeight: "300", fontSize: "5vw", margin: "-1vh 0 0vh 0",fontStyle:"italic",minHeight:"3vh" }} className="animated-title">{hashtag&&"#"+hashtag}</p>
         <div style={{ position: 'relative', display: 'inline-block' }}>
  <img
    src={media}
    className="profile-img"
    style={{
      width: '50vw',
      height: 'auto',
      transition: 'transform 1s ease-in-out'
    }}
  />
  <img
    src={ig}
    style={{
      position: 'absolute',
      top: '1vh',
      right: '1.5vw',
      width: '5vw', // adjust this value as needed
      height: 'auto', // or set a fixed height if needed
      zIndex: 1 // ensure it's on top of the original image
    }}
  />
</div>
<div style={{display:"flex",gap:"0.5vw",justifyContent:"center",alignItems:"center"}}>
<img onError={handleImageError}
        src={profile&&isValid?getProxiedImageUrl(profile):user}
        className="profile-img"
        width={name?30:0}
        style={{
          height:"auto",
          borderRadius:"50%",
          border: "3px solid white",
          transition: "transform 1s ease-in-out"
        }}
      />
<p style={{ color: colorTheme?colorTheme:"#703484", fontWeight: "600", fontSize: "4vw", margin: "0" }} className="animated-text">{name?name:""}</p>
</div>
        <p style={{ color: "black", fontWeight: "400", margin: "0",fontSize: "3vw"  }} className="animated-first">{testimonial}</p>
      </div>
    </div>
    )
  )
}

export default InstaFirst;
